/**
 * OurBricks studio: the order flow as an overlay on the shop.
 *
 *   house (a photo, or "No photo?" → Street View) → kit → you (email) → order (Shopify checkout)
 *
 * The draft lives on app.ourbricks.eu (token in localStorage, so a visitor resumes where they left off).
 * The checkout carries the token as the hidden line property `_studio`; the paid order claims the draft.
 * A gift skips the house: the buyer adds it after paying, through the link in their email (?ob_house=…).
 * Opened by every <a data-ob-app> (with data-ob-tier / data-ob-gift) and by .ob-tier__gift links.
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('ob-studio-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var API = String(CFG.api || '').replace(/\/+$/, '') + '/api/studio';
  var ROOT = CFG.root || '/';
  var STORE = 'ob_studio_token';

  var T = {
    nl: {
      kit_sides: "Foto's van de zij- en achterkant voeg je toe na je bestelling.", kit_sides_more: 'Meer info',
      kit_sides_info: "Na je bestelling krijg je een mail met een uploadlink. Daar voeg je, als je wil, foto's van de zijkanten en de achterkant toe. Geen foto's? Dan beelden wij de kanten in die we niet zien. We beginnen zodra je je foto's toevoegt, of na twee dagen.",
      example: 'Voorbeeld', mark_title: 'Duid je huis aan', mark_text: 'Staan er buren mee op? Sleep een kader rond je huis. Appartement? Neem het hele gebouw.', mark_ok: 'Dit is mijn huis', mark_edit: 'Duid je huis aan', mark_change: 'Aanpassen', built: 'Eerder gebouwd', kit_examples: 'Voorbeelden · {kit}', ex_foto: 'Foto', ex_ontwerp: '3D-ontwerp', ex_resultaat: 'Resultaat', close: 'Sluiten', back: 'Terug', next: 'Verder', steps: ['Je huis', 'Jij', 'Pakket', 'Bestellen'],
      house_title: 'Welk huis bouwen we?', house_text: 'Een foto of het adres. Allebei goed.',
      opt_photo: 'Foto van de voorkant', opt_photo_text: 'Ook een screenshot werkt.',
      opt_address: 'Zoek op adres', opt_address_text: 'Jij kiest je huis in het straatbeeld.',
      skip_q: 'Nog geen foto of adres?', skip_link: 'Ga verder zonder',
      skip_note: 'Geen probleem. Je voegt het toe na je bestelling.',
      you_title_later: 'Je e-mailadres', you_note_later: 'Na je bestelling krijg je de link voor het huis.',
      add_facade: 'Voeg je gevelfoto toe', or_after: 'of na je bestelling',
      restart: 'Ander huis', restart_text: 'Je huis en keuzes worden gewist.', restart_yes: 'Ja, ander huis', change: 'Wijzig', cancel: 'Annuleer',
      other_address: 'Ander adres', own_photo: 'Eigen foto',
      upload: 'Kies of maak een foto', uploading: 'Foto laden…', checking: 'Foto bekijken…', other_photo: 'Andere foto',
      check_ok: 'Top, daar kunnen we mee verder.', check_tip: 'Tip:', use_anyway: 'Deze foto is goed zo',
      no_photo: 'Geen foto bij de hand?', no_photo_link: 'Zoek je huis op adres',
      sv_title: 'Zoek je huis', sv_address: 'Adres van het huis', sv_placeholder: 'Straat en nummer, gemeente', sv_none: 'Niets gevonden. Probeer met postcode.',
      sv_frame: 'Zet je gevel mooi in beeld. Verkeerd huis? Volg de pijlen.',
      sv_ok: 'Dit is mijn huis', sv_other: 'Ander adres', sv_loading: 'Straatbeeld laden…', sv_saving: 'Even bewaren…',
      sv_nopano: 'Geen straatbeeld gevonden. Upload een foto van de voorkant.',
      sv_shot: 'Open Google Maps, zoek het adres en maak een screenshot van de gevel in het straatbeeld. Upload die hier.',
      sv_credit: 'Beeld: Google Street View',
      kit_title: 'Kies je pakket', recommended: 'Aanrader', pieces: 'ca. {n} steentjes',
      kit_mini: ['Mini', 'Een speelse mini van je gevel.'],
      kit_gevel: ['Gevel', 'De voorgevel tot in detail, op een voetstuk.'],
      kit_huis: ['Compleet', 'Het hele huis, van alle kanten.'],
      you_title: 'Je e-mailadres', you_note: 'Je 3D-ontwerp krijg je binnen 24 uur na je bestelling.', first_name: 'Voornaam', email: 'E-mailadres', email_bad: 'Vul een geldig e-mailadres in.',
      gift: 'Het is een cadeau', consent: 'Je ontwerp en een paar mails over je huis. Afmelden met één klik.',
      order_title: 'Klaar om te bouwen', order_title_gift: 'Een cadeau om te bouwen', my_design: 'Je eerste ontwerp',
      trust: [['Ontwerp in 24 u', 'Jouw huis in 3D'], ['Jij keurt goed', 'Niet blij? Geld terug'], ['Gratis bezorgd', 'Tot aan je deur']], pay_safe: 'Veilig betalen',
      order_btn: 'Bestellen', ordering: 'Naar de kassa…', gift_note: 'Verrassing blijft verrassing.',
      gift_title: 'Een cadeau: welk pakket?', error: 'Er ging iets mis. Probeer het nog eens.',
      resume_cta: 'Ga verder met je huis'
    },
    fr: {
      kit_sides: "Les photos des côtés et de l'arrière, vous les ajoutez après votre commande.", kit_sides_more: 'En savoir plus',
      kit_sides_info: "Après votre commande, vous recevez un mail avec un lien d'envoi. Vous pouvez y ajouter des photos des côtés et de l'arrière, si vous le souhaitez. Pas de photos\u00a0? Nous imaginons les côtés que nous ne voyons pas. Nous commençons dès que vous ajoutez vos photos, ou après deux jours.",
      example: 'Exemple', mark_title: 'Indiquez votre maison', mark_text: "Des voisins sur la photo ? Tracez un cadre autour de votre maison. Un appartement ? Prenez tout l'immeuble.", mark_ok: "C'est ma maison", mark_edit: 'Indiquez votre maison', mark_change: 'Modifier', built: 'Déjà construites', kit_examples: 'Exemples · {kit}', ex_foto: 'Photo', ex_ontwerp: 'Design 3D', ex_resultaat: 'Résultat', close: 'Fermer', back: 'Retour', next: 'Continuer', steps: ['Votre maison', 'Vous', 'Formule', 'Commander'],
      house_title: 'Quelle maison construisons-nous ?', house_text: "Une photo ou l'adresse. Les deux vont.",
      opt_photo: 'Photo de la façade', opt_photo_text: "Une capture d'écran convient aussi.",
      opt_address: 'Chercher par adresse', opt_address_text: 'Choisissez votre maison dans la vue de rue.',
      skip_q: "Pas encore de photo ni d'adresse ?", skip_link: 'Continuer sans',
      skip_note: 'Aucun souci. Vous l’ajoutez après votre commande.',
      you_title_later: 'Votre adresse e-mail', you_note_later: 'Après votre commande, vous recevez le lien pour la maison.',
      add_facade: 'Ajoutez la photo de votre façade', or_after: 'ou après votre commande',
      restart: 'Une autre maison', restart_text: 'Votre maison et vos choix seront effacés.', restart_yes: 'Oui, une autre maison', change: 'Modifier', cancel: 'Annuler',
      other_address: 'Autre adresse', own_photo: 'Ma photo',
      upload: 'Choisir ou prendre une photo', uploading: 'Chargement…', checking: 'Analyse de la photo…', other_photo: 'Autre photo',
      check_ok: 'Parfait, nous pouvons continuer.', check_tip: 'Astuce :', use_anyway: 'Cette photo convient',
      no_photo: 'Pas de photo sous la main ?', no_photo_link: 'Chercher votre maison par adresse',
      sv_title: 'Trouvez votre maison', sv_address: 'Adresse de la maison', sv_placeholder: 'Rue et numéro, commune', sv_none: 'Rien trouvé. Essayez avec le code postal.',
      sv_frame: 'Cadrez bien votre façade. Pas la bonne maison ? Suivez les flèches.',
      sv_ok: "C'est ma maison", sv_other: 'Autre adresse', sv_loading: 'Chargement de la vue…', sv_saving: 'Un instant…',
      sv_nopano: 'Pas de vue de rue trouvée. Chargez une photo de la façade.',
      sv_shot: "Ouvrez Google Maps, cherchez l'adresse et faites une capture de la façade dans la vue de rue. Chargez-la ici.",
      sv_credit: 'Image : Google Street View',
      kit_title: 'Choisissez votre formule', recommended: 'Notre conseil', pieces: 'environ {n} briques',
      kit_mini: ['Mini', 'Une mini ludique de votre façade.'],
      kit_gevel: ['Façade', 'La façade en détail, sur un socle.'],
      kit_huis: ['Complète', 'Toute la maison, de tous les côtés.'],
      you_title: 'Votre adresse e-mail', you_note: 'Votre design 3D arrive sous 24 heures après la commande.', first_name: 'Prénom', email: 'Adresse e-mail', email_bad: 'Indiquez une adresse e-mail valide.',
      gift: "C'est un cadeau", consent: 'Votre design et quelques mails sur votre maison. Désinscription en un clic.',
      order_title: 'Prêt à construire', order_title_gift: 'Un cadeau à construire', my_design: 'Votre premier design',
      trust: [['Design en 24 h', 'Votre maison en 3D'], ['Vous validez', 'Pas satisfait ? Remboursé'], ['Envoi gratuit', "Jusqu'à votre porte"]], pay_safe: 'Paiement sécurisé',
      order_btn: 'Commander', ordering: 'Vers la caisse…', gift_note: 'La surprise reste une surprise.',
      gift_title: 'Un cadeau : quelle formule ?', error: "Quelque chose n'a pas fonctionné. Réessayez.",
      resume_cta: 'Continuer avec votre maison'
    },
    en: {
      kit_sides: 'You add photos of the sides and back after your order.', kit_sides_more: 'More info',
      kit_sides_info: "After your order you get an email with an upload link. There you can add photos of the sides and the back, if you like. No photos? We imagine the sides we can't see. We start as soon as you add your photos, or after two days.",
      example: 'Example', mark_title: 'Mark your house', mark_text: 'Neighbours in the photo? Drag a frame around your house. An apartment? Take the whole building.', mark_ok: 'This is my house', mark_edit: 'Mark your house', mark_change: 'Change', built: 'Built before', kit_examples: 'Examples · {kit}', ex_foto: 'Photo', ex_ontwerp: '3D design', ex_resultaat: 'Result', close: 'Close', back: 'Back', next: 'Continue', steps: ['Your house', 'You', 'Kit', 'Order'],
      house_title: 'Which house shall we build?', house_text: 'A photo or the address. Both work.',
      opt_photo: 'Photo of the front', opt_photo_text: 'A screenshot works too.',
      opt_address: 'Find by address', opt_address_text: 'Pick your house in the street view.',
      skip_q: 'No photo or address yet?', skip_link: 'Continue without',
      skip_note: 'No problem. Add it after you order.',
      you_title_later: 'Your email address', you_note_later: "After ordering you'll get the link for the house.",
      add_facade: 'Add your facade photo', or_after: 'or after you order',
      restart: 'Another house', restart_text: 'Your house and choices will be cleared.', restart_yes: 'Yes, another house', change: 'Change', cancel: 'Cancel',
      other_address: 'Another address', own_photo: 'My own photo',
      upload: 'Choose or take a photo', uploading: 'Loading…', checking: 'Checking the photo…', other_photo: 'Another photo',
      check_ok: 'Great, we can work with this.', check_tip: 'Tip:', use_anyway: 'This photo is fine',
      no_photo: 'No photo at hand?', no_photo_link: 'Find your house by address',
      sv_title: 'Find your house', sv_address: 'Address of the house', sv_placeholder: 'Street and number, town', sv_none: 'Nothing found. Try with the postcode.',
      sv_frame: 'Frame your facade nicely. Wrong house? Follow the arrows.',
      sv_ok: 'This is my house', sv_other: 'Another address', sv_loading: 'Loading the street view…', sv_saving: 'Saving…',
      sv_nopano: 'No street view found. Upload a photo of the front.',
      sv_shot: 'Open Google Maps, search the address and screenshot the facade in street view. Upload it here.',
      sv_credit: 'Image: Google Street View',
      kit_title: 'Choose your kit', recommended: 'Our pick', pieces: 'about {n} bricks',
      kit_mini: ['Mini', 'A playful mini of your facade.'],
      kit_gevel: ['Facade', 'The front in full detail, on a base.'],
      kit_huis: ['Complete', 'The whole house, from every side.'],
      you_title: 'Your email address', you_note: 'Your 3D design arrives within 24 hours of ordering.', first_name: 'First name', email: 'Email address', email_bad: 'Please enter a valid email address.',
      gift: "It's a gift", consent: 'Your design and a few emails about your house. Unsubscribe in one click.',
      order_title: 'Ready to build', order_title_gift: 'A gift to build', my_design: 'Your first design',
      trust: [['Design in 24 h', 'Your house in 3D'], ['You approve', 'Not happy? Money back'], ['Free delivery', 'To your door']], pay_safe: 'Secure payment',
      order_btn: 'Order', ordering: 'To the checkout…', gift_note: 'The surprise stays a surprise.',
      gift_title: 'A gift: which kit?', error: 'Something went wrong. Please try again.',
      resume_cta: 'Continue with your house'
    }
  };
  var LANG = (String(CFG.locale || 'nl').slice(0, 2) in T) ? String(CFG.locale).slice(0, 2) : 'nl';
  function t(k, vars) {
    var s = T[LANG][k] !== undefined ? T[LANG][k] : T.nl[k];
    if (typeof s === 'string' && vars) Object.keys(vars).forEach(function (v) { s = s.replace('{' + v + '}', vars[v]); });
    return s;
  }
  var TIER = { facade: 'gevel', 'facade-garden': 'gevel', home: 'huis', mini: 'mini', gevel: 'gevel', huis: 'huis' };
  var KITS = ['mini', 'gevel', 'huis'];

  // --- small helpers -------------------------------------------------------------------------------
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== false && attrs[k] != null) n.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function money(cents) {
    try { return new Intl.NumberFormat(LANG + '-BE', { style: 'currency', currency: CFG.currency || 'EUR', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '€' + Math.round(cents / 100); }
  }
  function api(method, path, body) {
    var opts = { method: method, headers: {} };
    if (body instanceof FormData) opts.body = body;
    else if (body !== undefined) { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j.detail || r.status); e.status = r.status; throw e; } return j; });
    });
  }
  var session = (window.OurBricks && window.OurBricks.visit) || Math.random().toString(36).slice(2, 12);  // the visit's id: one page view, one session
  var testMode = /[?&]pb=0\b/.test(location.search) ? (store('ob_test', '1'), true) : store('ob_test') === '1';
  // Beacons that our server also passes to Meta (Conversions API, once per draft, same event id as the browser)
  // carry Meta's browser ids, the marketing consent and, for a kit, its value. Never stored by us.
  var SERVER_META = { open: 1, resume: 1, house_upload: 1, house_street_chosen: 1, kit: 1, order_shown: 1 };
  function beacon(name, data) {
    var meta = null;
    if (SERVER_META[name] && !testMode) {
      meta = metaIds();
      var k = name === 'kit' ? (data && data.kit) : (name === 'order_shown' && S.draft ? S.draft.kit : '');
      if (k) Object.assign(meta, kitValue(k));
    }
    var body = JSON.stringify({ name: name, token: S.token || null, session: session, data: data || {}, test: testMode, meta: meta || {} });
    try { if (navigator.sendBeacon && navigator.sendBeacon(API + '/events', body)) return; } catch (e) { /* fall through */ }
    fetch(API + '/events', { method: 'POST', body: body, keepalive: true }).catch(function () {});
  }
  /* Ad tracking. A milestone is sent once per draft (remembered in this browser, so a return to the same draft is
     not new) and, before there is a draft, once per browser session; a homepage block counts once per block.
     Every event goes to:
     - Shopify's customer events (Shopify.analytics.publish 'ob_<Event>'): every app pixel hears it, WeTracked too;
     - the Meta pixel when one is on the page: Lead, AddToCart and InitiateCheckout as standard events, the rest
       custom; the eventID lets Meta drop a copy it also gets server-side;
     - dataLayer ('ob_<Event>') and a DOM event ('ob:<Event>').
     Our own test browsers (?pb=0) send nothing. Nothing in here may ever stop a step. */
  var STANDARD = { Lead: 1 };
  // Shopify's Facebook & Instagram app already sends PageView, AddToCart, InitiateCheckout and Purchase (browser
  // and server): to Meta we send the rest, never those again.
  var APP_SENDS = { AddToCart: 1, InitiateCheckout: 1, PageView: 1, Purchase: 1 };
  // Our own copy of the Meta pixel (the app's runs sandboxed, out of reach), loaded only with marketing consent,
  // without automatic events.
  var metaReady = false, metaStarting = false, metaQueue = [];
  function metaSend(event, payload, key) {
    if (!metaReady) { if (metaQueue.length < 30) metaQueue.push([event, payload, key]); return; }  // until consent and the pixel are there
    try { if (typeof window.fbq === 'function') window.fbq(STANDARD[event] ? 'track' : 'trackCustom', event, payload, { eventID: key }); } catch (e) { /* no pixel */ }
  }
  function metaStart() {  // after the page has loaded, so Shopify's app has put its pixel on the page first (no double init)
    if (metaStarting || testMode || !CFG.meta_pixel) return;
    metaStarting = true;
    var go = function () { setTimeout(metaInit, 1200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  function metaInit() {
    try {
      /* eslint-disable */
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s) }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      var st = window.fbq.getState ? window.fbq.getState() : null;  // Shopify's Facebook & Instagram app may have put it on the page already
      var there = st && st.pixels && st.pixels.some(function (px) { return String(px.id) === String(CFG.meta_pixel); });
      if (!there) { window.fbq('set', 'autoConfig', false, CFG.meta_pixel); window.fbq('init', CFG.meta_pixel); }
    } catch (e) { /* no pixel */ }
    metaReady = true;
    metaUser();
    metaQueue.splice(0).forEach(function (q) { metaSend(q[0], q[1], q[2]); });
  }
  function metaConsent() {  // Shopify's consent: now, and again when the visitor answers the banner
    try {
      if (!window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed()) metaStart();
      });
      document.addEventListener('visitorConsentCollected', function (e) { if (e.detail && e.detail.marketingAllowed) metaStart(); });
    } catch (e) { /* no consent api: no pixel */ }
  }
  var TRACKED_KEY = 'ob_tracked';
  function once(event, data) {
    var key = event + ':' + ((data && data.block) || '') + ':' + (S.token || '');
    try {
      var box = S.token ? window.localStorage : window.sessionStorage;
      var sent = JSON.parse(box.getItem(TRACKED_KEY) || '[]');
      if (sent.indexOf(key) !== -1) return null;
      box.setItem(TRACKED_KEY, JSON.stringify(sent.concat([key]).slice(-400)));
    } catch (e) { /* no storage: at worst one extra event */ }
    return key;
  }
  function track(event, data) {
    if (testMode) return;
    var key; try { key = once(event, data); } catch (e) { key = event; }
    if (!key) return;
    var payload = Object.assign({ currency: CFG.currency || 'EUR' }, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ob_' + event, Object.assign({ event_id: key }, payload)); } catch (e) { /* no customer events */ }
    if (!APP_SENDS[event]) metaSend(event, payload, key);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'ob_' + event, event_id: key }, payload)); } catch (e) { /* no dataLayer */ }
    try { document.dispatchEvent(new CustomEvent('ob:' + event, { detail: payload })); } catch (e) { /* old browser */ }
  }
  function metaIds() {  // Meta's browser ids and the marketing consent, so the server-side events match this visitor (read, never set)
    var c = {}; try { document.cookie.split('; ').forEach(function (kv) { var i = kv.indexOf('='); c[kv.slice(0, i)] = kv.slice(i + 1); }); } catch (e) { /* none */ }
    return { fbp: c._fbp || '', fbc: c._fbc || '', url: location.origin + location.pathname, consent: marketingOk() };
  }
  function marketingOk() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; }
  }
  function leadValue() { var kit = CFG.kits[S.draft && S.draft.kit] || CFG.kits.gevel || {}; return (kit.price || 0) / 100; }
  // Advanced matching: the visitor's email (Meta hashes it in the browser before sending) and the draft as
  // external id, on the pixel, from the moment we have them.
  function metaUser() {
    if (!metaReady || !S.draft || !S.draft.email || typeof window.fbq !== 'function') return;
    try { window.fbq('init', CFG.meta_pixel, { em: S.draft.email.trim().toLowerCase(), external_id: String(S.token).toLowerCase() }); } catch (e) { /* no pixel */ }
  }
  function kitValue(k) { var kit = CFG.kits[k] || {}; return { content_name: k || '', content_ids: kit.variant ? [String(kit.variant)] : [], content_type: 'product', value: (kit.price || 0) / 100 }; }
  function utm() {
    var out = {}; try { Object.assign(out, JSON.parse(sessionStorage.getItem('ob_attribution') || '{}')); } catch (e) { /* none */ }
    return out;
  }

  // Downscale in the browser before uploading (phones make 12 MB photos). HEIC that the browser can't
  // decode goes up as it is.
  function shrink(file) {
    return new Promise(function (resolve) {
      if (!/^image\/(jpe?g|png|webp)$/i.test(file.type)) return resolve(file);
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var k = Math.min(1, 2400 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { resolve(b ? new File([b], 'house.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.9);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  // --- state ---------------------------------------------------------------------------------------
  var S = { token: null, draft: null, step: 'house', busy: false, config: null };
  var ORDER_STEPS = ['house', 'email', 'kit', 'order'];  // the email right after the house: every lead has their house
  function flow() { return ORDER_STEPS; }  // one route for everyone; a gift or "no photo yet" only changes words
  function firstOpen(d) {  // back where it makes sense: the first step not done yet
    if (!d.photos.length && !d.house_later) return 'house';
    if (!d.email) return 'email';
    if (!d.kit) return 'kit';
    return d.furthest === 'order' ? 'order' : 'kit';
  }
  function config() {
    if (S.config) return Promise.resolve(S.config);
    return api('GET', '/config').then(function (c) { S.config = c; return c; }).catch(function () { S.config = { streetview: false }; return S.config; });
  }
  function ensureDraft(opts) {
    if (S.draft && !S.draft.ordered) return Promise.resolve(S.draft);
    var saved = store(STORE);
    var load = saved ? api('GET', '/drafts/' + saved).catch(function () { return null; }) : Promise.resolve(null);
    return load.then(function (d) {
      if (d && !d.ordered) return d;
      return api('POST', '/drafts', { locale: LANG, kit: (opts && opts.kit) || '', gift: !!(opts && opts.gift), context: (opts && opts.context) || '', utm: Object.assign(utm(), testMode ? { test: '1' } : {}) });
    }).then(function (d) { S.draft = d; S.token = d.token; store(STORE, d.token); return d; });
  }
  function patch(fields) { return api('PATCH', '/drafts/' + S.token, fields).then(function (d) { S.draft = d; return d; }); }

  // --- the overlay ---------------------------------------------------------------------------------
  var root, body, foot, progress, backBtn, lastFocus;
  var ICON_BACK = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function build() {
    if (root) return;
    progress = el('ol', { class: 'obs-progress' });
    backBtn = el('button', { type: 'button', class: 'obs-backarrow', 'aria-label': t('back'), title: t('back'), html: ICON_BACK, onclick: function () { var f = flow(); S.returnTo = null; go(f[f.indexOf(S.step) - 1]); } });
    body = el('div', { class: 'obs-body' });
    foot = el('div', { class: 'obs-foot' });
    var panel = el('div', { class: 'obs-panel', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'OurBricks' }, [
      el('div', { class: 'obs-head' }, [backBtn, progress, el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: close, html: '&times;' })]),
      body, foot
    ]);
    root = el('div', { class: 'ob obs', hidden: true }, [el('div', { class: 'obs-backdrop', onclick: close }), panel]);
    document.body.appendChild(root);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) { if (modal) closeModal(); else close(); } });
  }
  function open(opts) {
    build();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('obs-open');
    body.innerHTML = ''; body.appendChild(loader());
    foot.innerHTML = '';
    config().then(function () { return ensureDraft(opts); }).then(function (d) {
      var fields = {};
      if (opts.kit && KITS.indexOf(opts.kit) >= 0) fields.kit = opts.kit;
      if (opts.gift) fields.gift = true;
      return Object.keys(fields).length ? patch(fields) : d;
    }).then(function (d) {
      beacon(opts.resume ? 'resume' : (opts.gift ? 'gift_start' : 'open'), { context: opts.context || '', kit: d.kit });
      metaUser();  // a returning visitor's email, for matching
      track(opts.resume ? 'StudioResume' : 'StudioOpen', { context: opts.context || '', kit: d.kit || '', gift: !!d.gift });
      go(firstOpen(d));
    }).catch(function () { body.innerHTML = ''; body.appendChild(el('p', { class: 'obs-error', text: t('error') })); });
  }
  function askRestart() {  // "Another house" on the house step; a fresh start only after a yes
    closeModal();
    var box = el('div', { class: 'obs-modal__box obs-confirm', role: 'alertdialog', 'aria-modal': 'true', 'aria-label': t('restart') }, [
      el('h3', { text: t('restart') + '?' }),
      el('p', { class: 'ob-muted', text: t('restart_text') }),
      el('div', { class: 'obs-confirm__btns' }, [
        el('button', { type: 'button', class: 'obs-link', text: t('cancel'), onclick: closeModal }),
        el('button', { type: 'button', class: 'ob-btn', text: t('restart_yes'), onclick: function () { closeModal(); restart(); } })
      ])
    ]);
    modal = el('div', { class: 'obs-modal' }, [el('div', { class: 'obs-backdrop', onclick: closeModal }), box]);
    root.querySelector('.obs-panel').appendChild(modal);
    box.querySelector('.ob-btn').focus();
  }
  function restart() {  // another house: a fresh draft (the old one stays on the server)
    track('StudioRestart', {});
    store(STORE, null); S.draft = null; S.token = null; S.cart = null; S.returnTo = null;
    open({ context: 'restart' });
  }
  function close() {
    if (!root) return;
    root.hidden = true;
    document.documentElement.classList.remove('obs-open');
    closeModal();
    checkStarted();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function go(step) {
    S.step = step;
    var steps = flow();
    progress.innerHTML = '';
    steps.forEach(function (s, i) {  // a brick they can reach is a button: one tap back to their house, or on to the order
      var d = S.draft, done = { house: d.photos.length > 0 || !!d.house_later, email: !!d.email, kit: !!d.kit, order: false }[s];
      var cls = 'obs-brick' + (s === step ? ' is-now' : done || i < steps.indexOf(step) ? ' is-done' : '');
      var jump = s !== step && reachable(s);
      progress.appendChild(el('li', { class: cls + (jump ? ' is-link' : '') }, [jump
        ? el('button', { type: 'button', class: 'obs-brick__btn', 'aria-label': t('steps')[i], onclick: function () { go(s); } }, [el('span', { text: t('steps')[i] })])
        : el('span', { text: t('steps')[i], 'aria-current': s === step ? 'step' : null })]));
    });
    backBtn.hidden = steps.indexOf(step) <= 0;
    if (step === 'order') S.returnTo = null;
    body.innerHTML = ''; foot.innerHTML = ''; foot.hidden = false;
    body.scrollTop = 0;
    ({ house: stepHouse, kit: stepKit, email: stepEmail, order: stepOrder })[step]();
    if (S.token && ORDER_STEPS.indexOf(step) > ORDER_STEPS.indexOf(S.draft.step)) patch({ step: step }).catch(function () {});
    var h = body.querySelector('h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }
  function reachable(s) {  // a step whose earlier steps are done (the house, or "later"; an email; a kit)
    var d = S.draft;
    if (!d) return false;
    var house = d.photos.length > 0 || !!d.house_later, email = house && !!d.email;
    return { house: true, email: house, kit: email, order: email && !!d.kit }[s] || false;
  }
  function nav(canNext, onNext, nextLabel) {  // one full-width button at the bottom; back is the arrow top left
    foot.innerHTML = '';
    if (onNext) {
      var b = el('button', { type: 'button', class: 'ob-btn obs-next', text: nextLabel || t('next'), disabled: !canNext, onclick: onNext });
      foot.appendChild(b);
      return b;
    }
  }
  function next() {  // on to the next step, or straight back to the order when they came from its Change
    var s = flow(), to = S.returnTo && reachable(S.returnTo) ? S.returnTo : s[s.indexOf(S.step) + 1];
    S.returnTo = null;
    go(to);
  }
  function change(step) { S.returnTo = 'order'; go(step); }
  function loader(text) {
    return el('div', { class: 'obs-loader', role: 'status' }, [el('div', { class: 'obs-stack' }, [el('i'), el('i'), el('i')]), text ? el('p', { class: 'ob-muted', text: text }) : null]);
  }

  // --- step 1: the house -----------------------------------------------------------------------------
  var ICON_PHOTO = '<svg viewBox="0 0 48 40" width="46" height="38" aria-hidden="true"><rect x="4" y="12" width="40" height="26" rx="4" fill="var(--ob-brick)"/><rect x="11" y="6" width="9" height="7" rx="2" fill="var(--ob-brick)"/><rect x="28" y="6" width="9" height="7" rx="2" fill="var(--ob-brick)"/><circle cx="24" cy="25" r="7.5" fill="none" stroke="#fff" stroke-width="3"/></svg>';
  var ICON_PIN = '<svg viewBox="0 0 48 40" width="46" height="38" aria-hidden="true"><path d="M24 3c-7.7 0-13 5.6-13 12.6C11 25 24 37 24 37s13-12 13-21.4C37 8.6 31.7 3 24 3z" fill="var(--ob-slate)"/><circle cx="24" cy="15.5" r="5" fill="#fff"/></svg>';
  function stepHouse() {
    var d = S.draft;
    body.appendChild(el('h2', { text: t('house_title') }));
    body.appendChild(el('p', { class: 'ob-muted', text: t('house_text') }));
    var input = el('input', { type: 'file', accept: 'image/*', class: 'ob-visually-hidden', id: 'obs-file' });
    input.addEventListener('change', function () { if (input.files[0]) upload(input.files[0], !d.photos.length || S.replaceFront); input.value = ''; });
    body.appendChild(input);
    if (!d.photos.length) {
      var photo = el('label', { class: 'obs-choice', for: 'obs-file' }, [el('span', { class: 'obs-choice__icon', html: ICON_PHOTO }), el('b', { text: t('opt_photo') }), el('span', { class: 'ob-muted', text: t('opt_photo_text') })]);
      photo.addEventListener('dragover', function (e) { e.preventDefault(); photo.classList.add('is-over'); });
      photo.addEventListener('dragleave', function () { photo.classList.remove('is-over'); });
      photo.addEventListener('drop', function (e) { e.preventDefault(); photo.classList.remove('is-over'); var f = e.dataTransfer.files[0]; if (f) upload(f, true); });
      var address = el('button', { type: 'button', class: 'obs-choice', onclick: openStreet }, [el('span', { class: 'obs-choice__icon', html: ICON_PIN }), el('b', { text: t('opt_address') }), el('span', { class: 'ob-muted', text: t('opt_address_text') })]);
      body.appendChild(el('div', { class: 'obs-choices' }, [photo, address]));
      if (!d.house_later) body.appendChild(el('div', { class: 'obs-skip' }, [
        el('p', {}, [el('b', { text: t('skip_q') + ' ' }), el('button', { type: 'button', class: 'obs-link', text: t('skip_link'), onclick: function () {
          patch({ house_later: true }).then(function () { beacon('house_later'); track('HouseLater', {}); next(); });
        } })]),
        el('p', { class: 'ob-muted obs-small', text: t('skip_note') })
      ]));
    } else if (checkPending(d)) {  // the house marked before the photo check was back: the bricks until it is
      body.appendChild(loader(t('checking')));
      var url = d.photos[0].url;
      checkFront().then(function () {  // redrawn in place (no focus move: the marking may still be open on top)
        if (S.step === 'house' && S.draft.photos[0] && S.draft.photos[0].url === url) { body.innerHTML = ''; foot.innerHTML = ''; stepHouse(); }
      });
      return;
    } else {
      var front = d.photos[0];
      var mark = front.box && !whole(front.box) ? el('span', { class: 'obs-photo__mark', style: 'left:' + front.box.x0 * 100 + '%;top:' + front.box.y0 * 100 + '%;width:' + (front.box.x1 - front.box.x0) * 100 + '%;height:' + (front.box.y1 - front.box.y0) * 100 + '%' }) : null;
      var pen = el('button', { type: 'button', class: 'obs-photo__edit', title: t('mark_edit'), 'aria-label': t('mark_edit'), onclick: function () { markHouse(front); },
        html: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16v4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M13.5 6.5l4 4" stroke="currentColor" stroke-width="2"/></svg>' });
      body.appendChild(el('figure', { class: 'obs-photo' }, [el('span', { class: 'obs-photo__frame' }, [el('img', { src: front.url, alt: '' }), mark, pen]), front.credit ? el('figcaption', { text: front.credit }) : null]));
      var c = checkOf(d);
      if (c.usable === false && c.tip) body.appendChild(el('p', { class: 'obs-note is-warn' }, [el('b', { text: t('check_tip') + ' ' }), c.tip]));
      else if (!c.streetview) body.appendChild(el('p', { class: 'obs-note is-ok', text: t('check_ok') }));
      var street = front.source === 'streetview';
      body.appendChild(el('div', { class: 'obs-swap' }, [  // the same two ways in, to change it
        el('button', { type: 'button', class: 'obs-swap__btn', onclick: function () { S.replaceFront = true; input.click(); } }, [el('span', { class: 'obs-swap__icon', html: ICON_PHOTO }), street ? t('own_photo') : t('other_photo')]),
        el('button', { type: 'button', class: 'obs-swap__btn', onclick: openStreet }, [el('span', { class: 'obs-swap__icon', html: ICON_PIN }), street ? t('other_address') : t('opt_address')])
      ]));
    }
    if (d.photos.length || d.email) body.appendChild(el('button', { type: 'button', class: 'obs-link obs-another', text: t('restart'), onclick: askRestart }));
    nav(d.photos.length > 0 || d.house_later, function () {
      if (d.photos.length) beacon(d.photos[0].source === 'streetview' ? 'house_street_chosen' : 'house_upload');
      next();
    });
  }
  // The AI check of the front photo runs while the visitor marks the house (slower than the upload, mostly faster
  // than the marking). One call per photo, kept by its url; it settles on the answer, an error, or after 15 s.
  var checks = {};
  function checkOf(d) {
    var c = d.photo_check || {}, p = d.photos[0], k = p && checks[p.url];
    return ('usable' in c || c.streetview || !k || !k.result) ? c : k.result;
  }
  function checkPending(d) {
    var p = d.photos[0], c = checkOf(d);
    return !!p && p.source !== 'streetview' && !('usable' in c) && !c.streetview && !(checks[p.url] && checks[p.url].settled);
  }
  function checkFront() {
    var p = S.draft.photos[0];
    if (!checkPending(S.draft)) return Promise.resolve();
    if (checks[p.url]) return checks[p.url].done;
    var k = checks[p.url] = { settled: false, result: null };
    var call = api('POST', '/drafts/' + S.token + '/photos/' + p.id + '/check').then(function (d) {
      k.result = d.photo_check || {};
      if (S.draft.photos[0] && S.draft.photos[0].url === p.url) S.draft.photo_check = k.result;
    }).catch(function () {});
    k.done = Promise.race([call, new Promise(function (ok) { setTimeout(ok, 15000); })]).then(function () { k.settled = true; });
    return k.done;
  }
  // "Duid je huis aan": a frame over the photo, moved by dragging inside it, sized by its corners, or drawn anew
  // by dragging outside it. Stored as fractions of the photo; the order gets the photo cropped to it.
  function markHouse(photo) {
    closeModal();
    var ALL = { x0: 0.05, y0: 0.05, x1: 0.95, y1: 0.95 };  // the whole photo (with the order's margin), until they draw a frame
    var b = photo.box || Object.assign({}, ALL);
    var box = el('div', { class: 'obs-modal__box obs-markbox', role: 'dialog', 'aria-modal': 'true', 'aria-label': t('mark_title') });
    modal = el('div', { class: 'obs-modal' }, [el('div', { class: 'obs-backdrop', onclick: closeModal }), box]);
    root.querySelector('.obs-panel').appendChild(modal);
    box.appendChild(el('div', { class: 'obs-modal__head' }, [el('h3', { text: t('mark_title') }), el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: closeModal, html: '&times;' })]));
    box.appendChild(el('p', { class: 'ob-muted obs-small', text: t('mark_text') }));
    var frame = el('div', { class: 'obs-mark__frame' }, ['tl', 'tr', 'bl', 'br'].map(function (c) { return el('span', { class: 'obs-mark__h obs-mark__h--' + c, 'data-h': c }); }));
    var stage = el('div', { class: 'obs-mark' }, [el('img', { src: photo.url, alt: '', draggable: 'false' }), frame]);
    box.appendChild(el('div', { class: 'obs-mark__wrap' }, [stage]));
    function draw() {
      frame.style.left = b.x0 * 100 + '%'; frame.style.top = b.y0 * 100 + '%';
      frame.style.width = (b.x1 - b.x0) * 100 + '%'; frame.style.height = (b.y1 - b.y0) * 100 + '%';
    }
    draw();
    var drag = null;
    function pt(e) { var r = stage.getBoundingClientRect(); return { x: Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), y: Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)) }; }
    stage.addEventListener('pointerdown', function (e) {
      e.preventDefault(); stage.setPointerCapture(e.pointerId);
      var p = pt(e), h = e.target.getAttribute && e.target.getAttribute('data-h');
      if (h) drag = { mode: h, b: Object.assign({}, b) };
      else if (!whole(b) && p.x > b.x0 && p.x < b.x1 && p.y > b.y0 && p.y < b.y1) drag = { mode: 'move', p: p, b: Object.assign({}, b) };
      else { b = { x0: p.x, y0: p.y, x1: p.x, y1: p.y }; drag = { mode: 'br', b: Object.assign({}, b) }; draw(); }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = pt(e), o = drag.b;
      if (drag.mode === 'move') {
        var dx = Math.min(1 - o.x1, Math.max(-o.x0, p.x - drag.p.x)), dy = Math.min(1 - o.y1, Math.max(-o.y0, p.y - drag.p.y));
        b = { x0: o.x0 + dx, y0: o.y0 + dy, x1: o.x1 + dx, y1: o.y1 + dy };
      } else {
        b = Object.assign({}, o);
        if (drag.mode.charAt(0) === 't') b.y0 = p.y; else b.y1 = p.y;
        if (drag.mode.charAt(1) === 'l') b.x0 = p.x; else b.x1 = p.x;
      }
      draw();
    });
    var end = function () {
      if (!drag) return; drag = null;
      b = { x0: Math.min(b.x0, b.x1), x1: Math.max(b.x0, b.x1), y0: Math.min(b.y0, b.y1), y1: Math.max(b.y0, b.y1) };
      if (b.x1 - b.x0 < 0.06) b.x1 = Math.min(1, b.x0 + 0.06);
      if (b.y1 - b.y0 < 0.06) b.y1 = Math.min(1, b.y0 + 0.06);
      draw();
    };
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    var ok = el('button', { type: 'button', class: 'ob-btn ob-btn--block', text: t('mark_ok'), onclick: function () {
      ok.disabled = true;
      api('POST', '/drafts/' + S.token + '/photos/' + photo.id + '/box', { box: b }).then(function (d) { S.draft = d; closeModal(); track('HouseMarked', {}); go('house'); })
        .catch(function () { ok.disabled = false; box.appendChild(el('p', { class: 'obs-error', text: t('error') })); });
    } });
    box.appendChild(ok);
  }
  function whole(b) {  // the frame plus the order's margin (12% of its size, studio.BOX_MARGIN) reaches every edge: the whole photo
    var mx = (b.x1 - b.x0) * 0.12, my = (b.y1 - b.y0) * 0.12;
    return b.x0 - mx <= 0 && b.y0 - my <= 0 && b.x1 + mx >= 1 && b.y1 + my >= 1;
  }
  function upload(file, front) {
    body.innerHTML = ''; body.appendChild(loader(t('uploading'))); foot.innerHTML = '';
    var old = S.replaceFront && S.draft.photos[0];
    shrink(file).then(function (f) {
      // replacing the front: remove the old one first (the new one then becomes the front)
      return (old ? api('DELETE', '/drafts/' + S.token + '/photos/' + old.id) : Promise.resolve(null)).then(function () {
        var fd = new FormData(); fd.append('photo', f, f.name || 'house.jpg');
        return api('POST', '/drafts/' + S.token + '/photos?front=' + (front ? 'true' : 'false'), fd);
      });
    }).then(function (d) { S.draft = d; S.replaceFront = false; track('HouseAdded', { source: 'upload' }); if (d.house_later) patch({ house_later: false }); go('house'); if (front && d.photos[0]) markHouse(d.photos[0]); })
      .catch(function () { S.replaceFront = false; go('house'); body.insertBefore(el('p', { class: 'obs-error', text: t('error') }), body.children[2]); });
  }
  // "No photo?": find the house by address and frame it in Street View (or, without it, how to make a screenshot)
  var modal = null, maps = null;
  function closeModal() {
    if (acRequests) { beacon('house_address_left', { ac: acRequests }); acRequests = 0; }  // a search without a pick: its suggestions are billed
    if (modal) { modal.remove(); modal = null; }
  }
  function openStreet() {
    beacon('house_no_photo'); track('HouseAddressStart', {});
    closeModal();
    var box = el('div', { class: 'obs-modal__box', role: 'dialog', 'aria-modal': 'true', 'aria-label': t('sv_title') });
    modal = el('div', { class: 'obs-modal' }, [el('div', { class: 'obs-backdrop', onclick: closeModal }), box]);
    root.querySelector('.obs-panel').appendChild(modal);
    renderAddress(box);
  }
  function renderAddress(box) {
    box.innerHTML = '';
    box.appendChild(el('div', { class: 'obs-modal__head' }, [el('h3', { text: t('sv_title') }), el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: closeModal, html: '&times;' })]));
    if (!S.config.streetview) { shotHelp(box); return; }
    var list = el('ul', { class: 'obs-suggest', role: 'listbox' });
    var input = el('input', { type: 'search', class: 'obs-input', placeholder: t('sv_placeholder'), autocomplete: 'street-address', 'aria-label': t('sv_address') });
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 4) { list.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var seq = ++searchSeq;
        findAddresses(q).then(function (results) {
          if (seq !== searchSeq) return;  // an older answer arriving late
          list.innerHTML = '';
          if (!results.length) { list.appendChild(el('li', { class: 'ob-muted', text: t('sv_none') })); return; }
          results.forEach(function (r) {
            list.appendChild(el('li', {}, [el('button', { type: 'button', role: 'option', text: r.label, onclick: function () {
              beacon('house_address', { g: r.g ? 1 : 0, ac: acRequests }); acRequests = 0;
              if (r.street) {  // a street without a number: start at number 1 (else the street itself); the arrows walk to the house
                var city = ((r.street.postcode || '') + ' ' + (r.street.city || '')).trim();
                findAddresses(r.street.street + ' 1' + (city ? ', ' + city : '')).then(function (res) {
                  var one = res.filter(function (x) { return !x.street && /\b1\b/.test(x.label); })[0];
                  return (one || r).resolve();
                }).catch(function () { return r.resolve(); }).then(function (a) { renderPano(box, a); })
                  .catch(function () { list.innerHTML = ''; list.appendChild(el('li', { class: 'ob-muted', text: t('sv_none') })); });
                return;
              }
              r.resolve().then(function (a) { renderPano(box, a); }).catch(function () { list.innerHTML = ''; list.appendChild(el('li', { class: 'ob-muted', text: t('sv_none') })); });
            } })]));
          });
        }).catch(function () {});
      }, 220);
    });
    box.appendChild(el('label', { class: 'obs-label', text: t('sv_address') }));
    box.appendChild(input);
    box.appendChild(list);
    setTimeout(function () { input.focus(); }, 30);
  }
  // Address search: Google Places (finds half-typed streets, places and numbers), our own search as a fallback.
  // Each result resolves to { label, street, number, postcode, city, country, lat, lon } when chosen.
  var searchSeq = 0, placesSession = null, acRequests = 0;  // Google suggestion requests since the last pick (priced in the cost ledger)
  function findAddresses(q) {
    return loadMaps().then(function (g) { return g.importLibrary ? g.importLibrary('places') : g.places; }).then(function (P) {
      if (!placesSession) placesSession = new P.AutocompleteSessionToken();
      var hint = S.addrHint && q.toLowerCase().indexOf(S.addrHint.street.toLowerCase()) === 0 && /\d/.test(q) ? ', ' + S.addrHint.city : '';
      acRequests++;
      return P.AutocompleteSuggestion.fetchAutocompleteSuggestions({ input: q + hint, sessionToken: placesSession, includedRegionCodes: ['be', 'nl', 'fr', 'lu'],
        includedPrimaryTypes: ['street_address', 'premise', 'subpremise', 'route'], language: LANG, region: 'be' })
        .then(function (res) {
          return (res.suggestions || []).filter(function (x) { return x.placePrediction; }).slice(0, 6).map(function (x) {
            var pp = x.placePrediction;
            var isStreet = (pp.types || []).indexOf('route') >= 0;  // a street: the visitor types the number next
            return { g: 1, label: pp.text.toString(), street: isStreet ? { street: pp.mainText ? pp.mainText.toString() : pp.text.toString(), city: pp.secondaryText ? pp.secondaryText.toString() : '' } : null, resolve: function () {
              var place = pp.toPlace();
              return place.fetchFields({ fields: ['location', 'formattedAddress', 'addressComponents'] }).then(function () {
                placesSession = null;  // a session ends with the choice
                var c = {}; (place.addressComponents || []).forEach(function (a) { (a.types || []).forEach(function (ty) { c[ty] = a; }); });
                var v = function (k, short) { return c[k] ? (short ? c[k].shortText : c[k].longText) : ''; };
                return { label: place.formattedAddress || pp.text.toString(), street: v('route'), number: v('street_number'), postcode: v('postal_code'),
                  city: v('locality') || v('postal_town') || v('administrative_area_level_2'), country: v('country', true), lat: place.location.lat(), lon: place.location.lng() };
              });
            } };
          });
        });
    }).catch(function () {
      var hint = S.addrHint && q.toLowerCase().indexOf(S.addrHint.street.toLowerCase()) === 0 && /\d/.test(q) ? ' ' + S.addrHint.city : '';
      return api('GET', '/address?locale=' + LANG + '&q=' + encodeURIComponent(q + hint)).then(function (r) {
        return r.results.map(function (a) { return { label: a.label, street: a.kind === 'street' ? a : null, resolve: function () { return Promise.resolve(a); } }; });
      });
    });
  }
  function shotHelp(box, text) {
    if (text) box.appendChild(el('p', { class: 'obs-note is-warn', text: text }));
    box.appendChild(el('p', { text: t('sv_shot') }));
    box.appendChild(el('label', { class: 'ob-btn ob-btn--block', for: 'obs-file', text: t('upload'), onclick: function () { setTimeout(closeModal, 50); } }));
  }
  var mapsFailed = null;  // set when Google refuses the key (gm_authFailure): the modal falls back to the screenshot tip
  function loadMaps() {
    if (maps) return maps;
    maps = new Promise(function (resolve, reject) {
      window.gm_authFailure = function () { if (mapsFailed) mapsFailed(); };
      window.__obMapsReady = function () { resolve(window.google.maps); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(S.config.maps_key) + '&v=weekly&libraries=geometry,places&loading=async&callback=__obMapsReady&language=' + LANG;
      s.async = true; s.onerror = reject;
      document.head.appendChild(s);
    });
    return maps;
  }
  function renderPano(box, a) {
    box.innerHTML = '';
    box.appendChild(el('div', { class: 'obs-modal__head' }, [el('h3', { text: a.label }), el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: closeModal, html: '&times;' })]));
    var view = el('div', { class: 'obs-pano' }, [loader(t('sv_loading'))]);
    box.appendChild(view);
    var fallback = function () {
      box.innerHTML = '';
      box.appendChild(el('div', { class: 'obs-modal__head' }, [el('h3', { text: t('sv_title') }), el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: closeModal, html: '&times;' })]));
      shotHelp(box);
    };
    mapsFailed = fallback;
    loadMaps().then(function (g) {
      var house = new g.LatLng(a.lat, a.lon);
      // Only Google's own Street View cars: user photo spheres (drones, 360° uploads) near an address look nothing
      // like a street view of the house. Nearest within 60 m, else within 150 m.
      var svs = new g.StreetViewService();
      var find = function (radius, done) {
        svs.getPanorama({ location: house, radius: radius, sources: [g.StreetViewSource.GOOGLE], preference: g.StreetViewPreference.NEAREST }, function (data, status) {
          if (status === 'OK' && data) done(data, status);
          else if (radius < 150) find(150, done);
          else done(data, status);
        });
      };
      find(60, function (data, status) {
        if (status !== 'OK' || !data) { view.remove(); shotHelp(box, t('sv_nopano')); box.appendChild(el('button', { type: 'button', class: 'obs-link', text: t('sv_other'), onclick: function () { renderAddress(box); } })); return; }
        view.innerHTML = '';
        var heading = g.geometry.spherical.computeHeading(data.location.latLng, house);
        var pano = new g.StreetViewPanorama(view, { pano: data.location.pano, pov: { heading: heading, pitch: 6 }, zoom: 0.6, addressControl: false, fullscreenControl: false, motionTracking: false, motionTrackingControl: false, showRoadLabels: false });
        box.appendChild(el('p', { class: 'obs-hint', text: t('sv_frame') }));
        var ok = el('button', { type: 'button', class: 'ob-btn ob-btn--block', text: t('sv_ok'), onclick: function () {
          ok.disabled = true; ok.textContent = t('sv_saving');
          var pov = pano.getPov(), zoom = pano.getZoom() || 0;
          api('POST', '/drafts/' + S.token + '/streetview', { pano: pano.getPano(), heading: pov.heading, pitch: pov.pitch, fov: 180 / Math.pow(2, zoom), address: a })
            .then(function (d) { S.draft = d; closeModal(); beacon('house_street_chosen'); track('HouseAdded', { source: 'streetview' }); if (d.house_later) patch({ house_later: false }); go('house'); if (d.photos[0]) markHouse(d.photos[0]); })
            .catch(function () { ok.disabled = false; ok.textContent = t('sv_ok'); box.appendChild(el('p', { class: 'obs-error', text: t('error') })); });
        } });
        box.appendChild(ok);
        box.appendChild(el('button', { type: 'button', class: 'obs-link', text: t('sv_other'), onclick: function () { renderAddress(box); } }));
        beacon('house_street_shown');
      });
    }).catch(fallback);
  }

  // --- step 2: the kit -------------------------------------------------------------------------------
  function stepKit() {
    var d = S.draft;
    body.appendChild(el('h2', { text: t('kit_title') }));
    var list = el('div', { class: 'obs-kits', role: 'radiogroup' });
    KITS.forEach(function (k) {
      var info = t('kit_' + k), kit = CFG.kits[k] || {};
      var card = el('button', { type: 'button', role: 'radio', 'aria-checked': d.kit === k ? 'true' : 'false', class: 'obs-kit' + (d.kit === k ? ' is-on' : ''), onclick: function () {
        patch({ kit: k }).then(function () { beacon('kit', { kit: k }); track('KitChosen', Object.assign(kitValue(k), { block: k })); go('kit'); });
      } }, [
        el('img', { src: CFG.images[k], alt: '', loading: 'lazy' }),
        el('span', { class: 'obs-kit__body' }, [
          el('span', { class: 'obs-kit__top' }, [el('b', { text: info[0] }), el('span', { class: 'obs-kit__price', text: kit.price ? money(kit.price) : '' })]),
          k === 'gevel' ? el('span', { class: 'ob-badge obs-kit__badge', text: t('recommended') }) : null,
          el('span', { class: 'obs-kit__pieces', text: t('pieces', { n: String(CFG.pieces[k] || '').replace('-', '–') }) }),
          el('span', { class: 'ob-muted', text: info[1] })
        ])
      ]);
      list.appendChild(card);
      if (k === 'huis' && d.kit === k) list.appendChild(kitSidesNote());
      var mine = (CFG.examples || []).filter(function (ex) { return ex.kit === k; });
      if (d.kit === k && mine.length) {  // the chosen kit: real examples of exactly this kit
        list.appendChild(el('div', { class: 'obs-built' }, [
          el('span', { class: 'obs-built__title', text: t('kit_examples', { kit: info[0] }) }),
          el('div', { class: 'obs-built__row' }, mine.slice(0, 3).map(function (ex, i) {
            return el('button', { type: 'button', class: 'obs-built__item', 'aria-label': ex.name || (t('kit_examples', { kit: info[0] }) + ' ' + (i + 1)), onclick: function () { track('KitExampleViewed', { content_name: k, block: k + (i + 1) }); showExample(ex); } }, [el('img', { src: ex.resultaat, alt: '', loading: 'lazy' })]);
          }))
        ]));
      }
    });
    body.appendChild(list);
    nav(!!d.kit, function () { next(); });
  }

  var ICON_INFO = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 11v6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="7.6" r="1.4" fill="currentColor"/></svg>';
  function kitSidesNote() {  // Compleet: one photo is enough, the other sides come after the order (the details behind the i)
    var tip = el('p', { class: 'obs-tip', id: 'obs-sides-tip', role: 'note', text: t('kit_sides_info') });
    var btn = el('button', { type: 'button', class: 'obs-info', 'aria-expanded': 'false', 'aria-controls': 'obs-sides-tip', 'aria-label': t('kit_sides_more'), title: t('kit_sides_more'), html: ICON_INFO });
    var box = el('div', { class: 'obs-kitnote' }, [el('p', { class: 'obs-kitnote__line' }, [el('span', { text: t('kit_sides') }), btn]), tip]);
    function set(on) { box.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); set(!box.classList.contains('is-open')); });
    box.addEventListener('click', function (e) { if (e.target !== btn && !btn.contains(e.target)) set(false); });  // a tap on the bubble closes it
    body.addEventListener('click', function outside(e) {  // a tap elsewhere closes it (gone with the step)
      if (!box.isConnected) { body.removeEventListener('click', outside); return; }
      if (!box.contains(e.target)) set(false);
    });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); set(false); btn.focus(); } });
    return box;
  }

  // --- step 3: you -----------------------------------------------------------------------------------
  function stepEmail() {
    var d = S.draft, has = d.photos.length > 0;
    body.appendChild(el('h2', { text: has ? t('you_title') : t('you_title_later') }));
    body.appendChild(el('p', { class: 'ob-muted', text: has ? t('you_note') : t('you_note_later') }));
    var mail = el('input', { class: 'obs-input', id: 'obs-mail', type: 'email', autocomplete: 'email', inputmode: 'email', value: d.email || '', required: true });
    var err = el('p', { class: 'obs-error', hidden: true, text: t('email_bad') });
    body.appendChild(el('label', { class: 'obs-label', for: 'obs-mail', text: t('email') })); body.appendChild(mail); body.appendChild(err);
    var gift = el('input', { type: 'checkbox', id: 'obs-gift', checked: d.gift });
    body.appendChild(el('label', { class: 'obs-check', for: 'obs-gift' }, [gift, el('span', { text: t('gift') })]));
    body.appendChild(el('p', { class: 'obs-consent ob-muted', text: t('consent') }));
    var valid = function () { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail.value.trim()); };
    var btn = nav(true, function () {
      if (!valid()) { err.hidden = false; mail.focus(); return; }
      btn.disabled = true;
      patch({ email: mail.value.trim(), consent: 'v1', gift: gift.checked, meta: Object.assign(metaIds(), { value: leadValue() }) }).then(function () {
        beacon('email'); metaUser(); track('Lead', { content_name: S.draft.kit || '', value: leadValue(), gift: !!S.draft.gift, house: S.draft.photos.length ? (S.draft.photos[0].source || 'upload') : 'later' });
        next();
      }).catch(function () { btn.disabled = false; });
    }, t('next'));
    mail.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
    setTimeout(function () { if (!mail.value) mail.focus(); }, 60);
  }

  // --- step 4: order ---------------------------------------------------------------------------------
  var ICON_TRUST = [
    '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M12 2.5 3.5 7v10L12 21.5 20.5 17V7z" fill="var(--ob-brick)"/><path d="M3.8 7.2 12 11.5l8.2-4.3M12 11.5v9.6" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M12 2.5 4 5.5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10v-6z" fill="var(--ob-sage-deep)"/><path d="m8.3 12.2 2.6 2.6 5-5.2" fill="none" stroke="#fff" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M2.5 6.5h11v9h-11z" fill="var(--ob-slate)"/><path d="M13.5 9.5h4l3 3.2v2.8h-7z" fill="var(--ob-slate)"/><circle cx="6.5" cy="17" r="2.2" fill="var(--ob-ink)" stroke="#fff" stroke-width="1.3"/><circle cx="16.8" cy="17" r="2.2" fill="var(--ob-ink)" stroke="#fff" stroke-width="1.3"/></svg>'
  ];
  function stepOrder() {
    var d = S.draft, kit = CFG.kits[d.kit] || {}, info = t('kit_' + (d.kit || 'gevel'));
    var price = kit.price ? money(kit.price) : '';
    beacon('order_shown'); track('OrderStepViewed', kitValue(d.kit));
    prepareCart(kit);  // the kit goes in the cart on arrival: AddToCart, and the button only has to go to the checkout
    foot.hidden = true;  // one button on this step, in the card: no footer competing with it
    body.appendChild(el('h2', { text: d.gift ? t('order_title_gift') : t('order_title') }));
    var img = d.photos[0] ? d.photos[0].url + (d.photos[0].box && !whole(d.photos[0].box) ? (d.photos[0].url.indexOf('?') < 0 ? '?' : '&') + 'crop=1' : '') : CFG.images[d.kit];  // the part the order gets
    var label = t('order_btn');  // the price stands large right above it
    var card;
    var btn = el('button', { type: 'button', class: 'ob-btn ob-btn--block obs-buy__btn', text: label, disabled: !kit.variant, onclick: function () {
      btn.disabled = true; btn.textContent = t('ordering');
      beacon('checkout', { kit: d.kit }); track('InitiateCheckout', Object.assign(kitValue(d.kit), { num_items: 1 }));
      checkout(kit).catch(function () { btn.disabled = false; btn.textContent = label; card.appendChild(el('p', { class: 'obs-error', text: t('error') })); });
    } });
    // a lead who got their first design by mail (the design test): their 3D model here, spinning and draggable
    var design = d.design && d.design.embed && d.design.kit === d.kit ? d.design : null;
    card = el('div', { class: 'obs-buy' }, [  // one path for the eye: their house, what and how much, the button
      design ? el('div', { class: 'obs-buy__media obs-buy__media--3d' }, [
        el('iframe', { class: 'obs-buy__model', src: design.embed, title: t('my_design'), loading: 'lazy' }),
        el('span', { class: 'obs-buy__tag', text: t('my_design') })
      ]) : img ? el('button', { type: 'button', class: 'obs-buy__media', onclick: function () { change('house'); } }, [
        el('img', { class: 'obs-buy__img', src: img, alt: '' }), d.photos[0] ? null : el('span', { class: 'obs-buy__tag', text: t('example') }),
        el('span', { class: 'obs-buy__change' + (d.photos[0] ? '' : ' is-add') }, [el('span', { html: ICON_PHOTO }), d.photos[0] ? t('change')
          : el('span', { class: 'obs-buy__add' }, [el('b', { text: t('add_facade') }), el('span', { text: t('or_after') })])])
      ]) : null,
      el('div', { class: 'obs-buy__row' }, [
        el('div', { class: 'obs-buy__info' }, [
          el('span', { class: 'obs-buy__kitline' }, [el('b', { class: 'obs-buy__kit', text: info[0] }), el('button', { type: 'button', class: 'obs-link obs-buy__kitchange', text: t('change'), onclick: function () { change('kit'); } })]),
          el('span', { class: 'obs-buy__pieces', text: t('pieces', { n: String(CFG.pieces[d.kit] || '').replace('-', '–') }) })
        ]),
        el('span', { class: 'obs-buy__price', text: price })
      ]),
      btn,
      CFG.payments ? el('div', { class: 'obs-pay', 'aria-label': t('pay_safe') }, [el('span', { class: 'obs-pay__icons', html: CFG.payments })]) : null
    ]);
    body.appendChild(card);
    body.appendChild(el('ol', { class: 'obs-trust' },  // what happens next and why it is safe, in one row
      t('trust').map(function (x, i) {
      return el('li', {}, [el('span', { class: 'obs-trust__icon', html: ICON_TRUST[i] }), el('b', { text: x[0] }), el('span', { text: x[1] })]);
    })));
    var notes = [d.gift ? t('gift_note') : null].filter(Boolean);
    if (notes.length) body.appendChild(el('div', { class: 'obs-order-note' }, notes.map(function (n) { return el('div', { text: n }); })));
  }
  function cartCall(path, data) {
    return fetch(ROOT.replace(/\/?$/, '/') + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data || {}) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function showExample(ex) {
    closeModal();
    var title = ex.name || t('built'), alt = ex.alt || {};
    var box = el('div', { class: 'obs-modal__box obs-exbox', role: 'dialog', 'aria-modal': 'true', 'aria-label': title }, [
      el('div', { class: 'obs-modal__head' }, [el('h3', { text: title }), el('button', { type: 'button', class: 'obs-close', 'aria-label': t('close'), onclick: closeModal, html: '&times;' })]),
      el('div', { class: 'obs-exbox__row' }, ['foto', 'ontwerp', 'resultaat'].filter(function (k) { return ex[k]; }).map(function (k) {
        return el('figure', { class: 'obs-exbox__' + k }, [el('img', { src: ex[k], alt: alt[k] || '' }), el('figcaption', { text: t('ex_' + k) })]);
      }))
    ]);
    modal = el('div', { class: 'obs-modal' }, [el('div', { class: 'obs-backdrop', onclick: closeModal }), box]);
    root.querySelector('.obs-panel').appendChild(modal);
  }
  function prepareCart(kit) {
    // One kit per cart, carrying the draft: the paid order claims it (webhook, property _studio).
    // Done once per draft and kit, on arriving at the order step; AddToCart fires then.
    if (!kit.variant) return Promise.reject(new Error('no variant'));
    var key = S.token + ':' + kit.variant;
    if (S.cart && S.cart.key === key) return S.cart.done;
    var done = cartCall('cart/clear.js').then(function () {
      return cartCall('cart/add.js', { items: [{ id: kit.variant, quantity: 1, properties: { _studio: S.token } }] });
    }).then(function () {
      return cartCall('cart/update.js', { attributes: Object.assign({ ob_studio: S.token }, utm()) });
    }).then(function () {
      beacon('cart', { kit: S.draft.kit });
      track('AddToCart', kitValue(S.draft.kit));
    });
    S.cart = { key: key, done: done };
    done.catch(function () { if (S.cart && S.cart.key === key) S.cart = null; });  // try again at the button
    return done;
  }
  function cartEmail(email) {
    // The email from the studio on the cart's buyer (Storefront API, tokenless): the checkout opens with it filled in.
    // Never blocks the checkout: a failure or a slow answer (2.5 s) goes on without it.
    if (!email) return Promise.resolve();
    var q = 'mutation($id: ID!, $b: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { userErrors { message } } }';
    var set = fetch(ROOT.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      return fetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: q, variables: { id: 'gid://shopify/Cart/' + cart.token, b: { email: email } } }) });
    }).catch(function () {});
    return Promise.race([set, new Promise(function (ok) { setTimeout(ok, 2500); })]);
  }
  function checkout(kit) {
    var email = S.draft && S.draft.email;
    return prepareCart(kit).then(function () { return cartEmail(email); }).then(function () {
      // the URL parameter as a second way in (the checkout reads it on /fr/ and /en/, not on the root path)
      window.location.href = ROOT.replace(/\/?$/, '/') + 'checkout' + (email ? '?checkout%5Bemail%5D=' + encodeURIComponent(email) : '');
    });
  }

  // --- wiring --------------------------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ob-app], .ob-tier__gift, [data-ob-studio]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var tierEl = a.closest('[data-ob-tier]') || a;
    var tier = a.getAttribute('data-ob-tier') || (a.classList.contains('ob-tier__gift') && a.closest('.ob-tier') && a.closest('.ob-tier').querySelector('[data-ob-tier]') && a.closest('.ob-tier').querySelector('[data-ob-tier]').getAttribute('data-ob-tier')) || tierEl.getAttribute('data-ob-tier');
    var gift = a.getAttribute('data-ob-gift') === 'true' || a.classList.contains('ob-tier__gift');  // only ticks "it's a gift"
    open({ kit: TIER[tier] || '', gift: gift, context: a.getAttribute('data-ob-context') || (a.closest('section') && a.closest('section').id) || '' });
  });
  var params = new URLSearchParams(location.search);
  function relabel(on) {  // a visitor who already started: the start buttons say "continue" (not the gift links)
    document.querySelectorAll('a[data-ob-app]').forEach(function (a) {
      if (a.getAttribute('data-ob-gift') === 'true') return;
      var node = Array.prototype.find.call(a.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (!node) return;
      if (!a.hasAttribute('data-ob-label')) a.setAttribute('data-ob-label', node.textContent);
      node.textContent = on ? t('resume_cta') : a.getAttribute('data-ob-label');
    });
  }
  function checkStarted() {
    var saved = store(STORE);
    if (!saved) return relabel(false);
    api('GET', '/drafts/' + saved).then(function (d) { relabel(!d.ordered && (d.photos.length > 0 || !!d.kit || d.house_later)); }).catch(function () {});
  }
  function boot() {
    checkStarted();
    if (params.get('ob_house')) {  // an older mail's photo link: the photo page lives on the app now
      location.replace(String(CFG.api || 'https://app.ourbricks.eu').replace(/\/+$/, '') + '/u/' + encodeURIComponent(params.get('ob_house')));
      return;
    }
    else if (params.get('ob_resume')) { store(STORE, params.get('ob_resume')); open({ resume: true, context: 'email' }); }
    else if (params.get('ob_studio')) {  // a start button's own link (a new tab, or clicked before this script loaded)
      open({ kit: TIER[params.get('tier')] || '', gift: params.get('gift') === '1', context: 'link' });
      try { var u = new URL(location.href); ['ob_studio', 'tier', 'gift', 'occasion'].forEach(function (k) { u.searchParams.delete(k); }); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { /* keep the url */ }
    }
  }
  // How far down the homepage people read: each OurBricks section once, when half of it has been in view
  function scrollDepth() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {  // half of the section, or half of the screen for a section taller than the screen
        var seen = e.intersectionRect.height;
        if (!e.isIntersecting || seen < Math.min(e.boundingClientRect.height, window.innerHeight) * 0.5) return;
        io.unobserve(e.target);
        track('ScrollDepth', { block: e.target.id.split('__').pop() });
      });
    }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6] });
    document.querySelectorAll('[id^="shopify-section-template"]').forEach(function (s) { if (s.querySelector('.ob')) io.observe(s); });
  }
  document.addEventListener('ob:example', function (e) { track('ExampleViewed', { content_name: (e.detail && e.detail.kit) || '', block: 'example' + ((e.detail && e.detail.index) || '') }); });
  metaConsent();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); scrollDepth(); }); else { boot(); scrollDepth(); }
  window.OurBricksStudio = { open: open, close: close };
})();
